import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-content" }
const _hoisted_3 = { class: "sm:grid sm:grid-cols-2 sm:gap-[25px]" }
const _hoisted_4 = {
  class: "mb-[20px] sm:mb-0 relative",
  id: "passwordHideShow"
}
const _hoisted_5 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_6 = ["placeholder", "type"]
const _hoisted_7 = {
  class: "mb-[20px] sm:mb-0 relative",
  id: "passwordHideShow2"
}
const _hoisted_8 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_9 = ["placeholder", "type"]
const _hoisted_10 = {
  class: "sm:col-span-2 mb-[20px] sm:mb-0 relative",
  id: "passwordHideShow3"
}
const _hoisted_11 = { class: "mb-[10px] text-black dark:text-white font-medium block" }
const _hoisted_12 = ["placeholder", "type"]
const _hoisted_13 = {
  key: 0,
  class: "text-danger-500 mt-2"
}
const _hoisted_14 = {
  key: 0,
  class: "mt-4 sm:col-span-2"
}
const _hoisted_15 = {
  key: 0,
  class: "p-3 bg-green-100 text-green-700 rounded-md"
}
const _hoisted_16 = {
  key: 1,
  class: "p-3 bg-red-100 text-red-700 rounded-md"
}
const _hoisted_17 = { class: "mt-[20px] md:mt-[25px]" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "inline-block relative ltr:pl-[29px] rtl:pr-[29px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingsNav = _resolveComponent("SettingsNav")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SettingsNav),
      _createElementVNode("form", {
        onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.changePassword && _ctx.changePassword(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.directT('settings.changePassword.oldPassword')), 1),
            _withDirectives(_createElementVNode("input", {
              class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
              id: "password",
              placeholder: _ctx.directT('settings.changePassword.typePlaceholder'),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.oldPassword) = $event)),
              type: _ctx.showPassword1 ? 'text' : 'password',
              required: ""
            }, null, 8, _hoisted_6), [
              [_vModelDynamic, _ctx.oldPassword]
            ]),
            _createElementVNode("button", {
              class: "absolute text-lg ltr:right-[20px] rtl:left-[20px] bottom-[13px] transition-all hover:text-primary-500",
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.togglePasswordVisibility(1)))
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(_ctx.showPassword1 ? 'ri-eye-line' : 'ri-eye-off-line')
              }, null, 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.directT('settings.changePassword.newPassword')), 1),
            _withDirectives(_createElementVNode("input", {
              class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
              id: "password2",
              placeholder: _ctx.directT('settings.changePassword.typePlaceholder'),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newPassword) = $event)),
              type: _ctx.showPassword2 ? 'text' : 'password',
              required: "",
              minlength: "6"
            }, null, 8, _hoisted_9), [
              [_vModelDynamic, _ctx.newPassword]
            ]),
            _createElementVNode("button", {
              class: "absolute text-lg ltr:right-[20px] rtl:left-[20px] bottom-[13px] transition-all hover:text-primary-500",
              type: "button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.togglePasswordVisibility(2)))
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(_ctx.showPassword2 ? 'ri-eye-line' : 'ri-eye-off-line')
              }, null, 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.directT('settings.changePassword.confirmPassword')), 1),
            _withDirectives(_createElementVNode("input", {
              class: "h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500",
              id: "password3",
              placeholder: _ctx.directT('settings.changePassword.typePlaceholder'),
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.confirmPassword) = $event)),
              type: _ctx.showPassword3 ? 'text' : 'password',
              required: "",
              minlength: "6"
            }, null, 8, _hoisted_12), [
              [_vModelDynamic, _ctx.confirmPassword]
            ]),
            _createElementVNode("button", {
              class: "absolute text-lg ltr:right-[20px] rtl:left-[20px] bottom-[13px] transition-all hover:text-primary-500",
              type: "button",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.togglePasswordVisibility(3)))
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(_ctx.showPassword3 ? 'ri-eye-line' : 'ri-eye-off-line')
              }, null, 2)
            ]),
            (_ctx.passwordMismatch)
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.directT('settings.changePassword.passwordsDoNotMatch')), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.successMessage || _ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (_ctx.successMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.successMessage), 1))
                : _createCommentVNode("", true),
              (_ctx.errorMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.errorMessage), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("button", {
            type: "submit",
            class: "font-medium inline-block transition-all rounded-md md:text-md py-[10px] md:py-[12px] px-[20px] md:px-[22px] bg-primary-500 text-white hover:bg-primary-400",
            disabled: _ctx.isLoading
          }, [
            _createElementVNode("span", _hoisted_19, [
              _cache[7] || (_cache[7] = _createElementVNode("i", { class: "material-symbols-outlined ltr:left-0 rtl:right-0 absolute top-1/2 -translate-y-1/2" }, " check ", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.isLoading ? _ctx.directT('settings.changePassword.updating') : _ctx.directT('settings.changePassword.updatePassword')), 1)
            ])
          ], 8, _hoisted_18),
          _createVNode(_component_RouterLink, {
            to: "/authentication/forgot-password",
            class: "inline-block text-danger-500 ltr:ml-[23px] rtl:mr-[23px]"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.directT('settings.changePassword.forgotPassword')), 1)
            ]),
            _: 1
          })
        ])
      ], 32)
    ])
  ]))
}